import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import PropTypes from "prop-types";
import useLanguageChange from "../../../../hooks/useLanguageChange";
import { MEDIA_PERMISSIONS } from "../../../../constants/CallSettingConstants";
import { setCurrentCameraDevice, setIsFrontCameraSelected } from "../../../../reducers/call-setting-reducer";
import { LogFirebase } from "../../../../services/firestore";

const CameraDropDown = ({ askPermission, cameraDeviceUpdate }) => {
    const dispatch = useDispatch();
    const localisedValues = useLanguageChange();

    const { isCameraExist, cameraPermission, cameraDevices, currentCameraDevice, isFrontCameraSelected } = useSelector((state) => state.callSetting);

    const cameraLabelText = useMemo(() => {
        let text = "";
        if (!isCameraExist) {
            text = localisedValues["camera_not_found"];
        } else if (cameraPermission === MEDIA_PERMISSIONS.PROMPT) {
            text = localisedValues["grant_permission"];
        } else if (cameraPermission === MEDIA_PERMISSIONS.ERROR || cameraPermission === MEDIA_PERMISSIONS.BLOCKED) {
            text = localisedValues["camera_blocked"];
        } else if (cameraPermission === MEDIA_PERMISSIONS.GRANTED) {
            text = currentCameraDevice?.label;
        }

        return text;
    }, [isCameraExist, cameraPermission, currentCameraDevice, localisedValues]);

    const handleCameraDeviceChange = (device) => {
        if (currentCameraDevice?.deviceId !== device.deviceId) {
            dispatch(setIsFrontCameraSelected(!isFrontCameraSelected));
            dispatch(setCurrentCameraDevice(device));
            LogFirebase("CallSettings", "selectedCamera", device.label);
            cameraDeviceUpdate();
        }
    };

    const onClickPermissionDropdown = () => {
        if (
            isCameraExist &&
            (cameraPermission === MEDIA_PERMISSIONS.PROMPT ||
                cameraPermission === MEDIA_PERMISSIONS.ERROR ||
                cameraPermission === MEDIA_PERMISSIONS.BLOCKED)
        ) {
            askPermission();
        }
    };

    return (
        <div className='form-group'>
            <label className='form-label'>{localisedValues["camera"]}</label>
            <div className='dropdown custom-dropdown dropdown-select call-settings-dropdown'>
                <button
                    className='btn dropdown-toggle triangle-none'
                    type='button'
                    aria-expanded='false'
                    data-bs-toggle={cameraPermission === MEDIA_PERMISSIONS.GRANTED && "dropdown"}
                    disabled={cameraPermission === MEDIA_PERMISSIONS.ERROR || cameraPermission === MEDIA_PERMISSIONS.BLOCKED || !isCameraExist}
                    onClick={onClickPermissionDropdown}
                >
                    <span className='btn-text'>{cameraLabelText}</span>
                    <span className='dropdown-toggle-arrow icon-down-arrow-light'></span>
                </button>
                {cameraPermission === MEDIA_PERMISSIONS.GRANTED && (
                    <div className='dropdown-menu'>
                        <div className='dropdown-menu-in custom-scroll-thin'>
                            <ul>
                                {cameraDevices.map((camera) => {
                                    const isSelectedCamera = camera.deviceId === currentCameraDevice?.deviceId;
                                    return (
                                        <li key={camera.deviceId}>
                                            <button
                                                className={clsx("btn dropdown-item", isSelectedCamera && "active")}
                                                onClick={() => handleCameraDeviceChange(camera)}
                                            >
                                                {camera.label}
                                            </button>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

CameraDropDown.propTypes = {
    askPermission: PropTypes.func,
    cameraDeviceUpdate: PropTypes.func,
};

export default CameraDropDown;
